import Icons from "@/assets/icons";
import { messageService } from "@/services/MessageService";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

interface Language {
  languages: string[];
}

const Language: React.FC<Language> = ({ languages }) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const [isResponsive, setIsResponsive] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsResponsive(window.innerWidth <= 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const messageTitle = t("languageComponent.message.title");
  const messageText = t("languageComponent.message.text");

  // Constantes de estilização
  const ContainerStyle =
    "z-1 bg-neutro-50 rounded-md shadow-md";
  const DropButtonStyle = `duration-200 cursor-pointer font-medium hover:fill-white flex items-center py-2 px-4 ${
    open ? "rounded-t-md" : "rounded-md"
  } w-full hover:bg-neutro-400 hover:text-white border-b border-neutral-300`;
  const LangOptionsStyle =
    "duration-200 p-2 hover:bg-neutro-200 cursor-pointer";

  const handleLanguageChange = (language: string) => {
    localStorage.setItem("lang", language);
    window.location.reload();
  };

  return (
    <div className={ContainerStyle}>
      <button className={DropButtonStyle} onClick={() => setOpen(!open)}>
        <span className="flex md:mr-4 gap-2">
          <Icons.Language pathStyle="fill-inherit" />
          <p className="max-md:hidden">{t("languageComponent.title")}</p>
        </span>
        {!isResponsive && <Icons.ArrowDown pathStyle="fill-inherit" />}
      </button>
      {open && (
        <div className="flex flex-col justify-start">
          {languages.map((language) => (
            <button
              key={language}
              onClick={() => {
                messageService.confirm(messageTitle, messageText, () =>
                  handleLanguageChange(language)
                );
              }}
              className={LangOptionsStyle}
            >
              <p className={`${isResponsive && "uppercase"}`}>
                {isResponsive ? language : t(`languageComponent.${[language]}`)}
              </p>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default Language;
